import { apiAction, appendQuery } from 'client/redux/apiHelpers';

export const instanceLogFragment = (types, query) => apiAction({
  endpoint: appendQuery('/api/instance/log/fragment', query),
  method: 'GET',
  types,
});
